import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/query-keys';
import { financialService } from '../../services/financial.service';
import { httpClient } from '../../services/http.client';

export function useTimesheets(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.timesheets.all(orgId ?? ''),
    queryFn: () => financialService.getTimesheets(orgId!),
    enabled: !!orgId,
    staleTime: 30_000,
    select: (res: any) => Array.isArray(res.data) ? res.data : res.data?.data ?? [],
  });
}

export function useTimesheetEntries(timesheetId: string | null) {
  return useQuery({
    queryKey: queryKeys.timesheets.entries(timesheetId ?? ''),
    queryFn: () => httpClient.get(`/api/v1/timesheet-entries?timesheet_id=${timesheetId}`),
    enabled: !!timesheetId,
    staleTime: 30_000,
    select: (res: any) => Array.isArray(res.data) ? res.data : [],
  });
}
